import React from 'react'
import Container from './container'
import Navigation from './navigation'
import Footer from '../components/footer';
import '../styles/global/base.scss';
class Template extends React.Component {
  render() {
    const { children } = this.props

    return (
      <Container>
        <Navigation />
        {children}
        <Footer/>
      </Container>
    )
  }
}

export default Template
